(function () {
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function debugEnabled() {
    try {
      return location.search.indexOf('ed_debug=1') !== -1 || localStorage.getItem('edDebug') === '1';
    } catch (e) {
      return false;
    }
  }

  function renderDebug(lines) {
    var box = document.getElementById('ed-bg-debug-box');
    if (!box) {
      box = document.createElement('div');
      box.id = 'ed-bg-debug-box';
      box.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:999999;background:#000;color:#0f0;' +
        'font:11px/1.4 monospace;padding:8px;max-height:60vh;overflow:auto;white-space:pre-wrap;' +
        'word-break:break-all;pointer-events:none;';
      document.documentElement.appendChild(box);
    }
    box.textContent = lines.join('\n');
  }

  function positionFreeGroups() {
    var debug = debugEnabled();
    var log = [];
    log.push('ed-button-group.js run @ ' + new Date().toISOString().slice(11, 19));
    log.push('innerWidth=' + window.innerWidth + ' innerHeight=' + window.innerHeight);

    try {
      var groups = document.querySelectorAll('.ed-button-group.ed-bg-free');
      log.push('groups found: ' + groups.length);

      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var gLog = ['--- group ' + i + ' ---'];
        gLog.push('class=' + group.className);

        var slide = group.closest('.slideshow__slide') || group.closest('.ed-button-group-section');
        var anchor = group.offsetParent;

        gLog.push('slide found=' + !!slide + (slide ? ' (' + slide.className + ')' : ''));
        gLog.push('offsetParent=' + (anchor ? (anchor.tagName + '.' + anchor.className) : 'null'));

        if (!slide || !anchor) {
          gLog.push('SKIPPED: missing slide or anchor');
          log = log.concat(gLog);
          continue;
        }

        var slideRect = slide.getBoundingClientRect();
        var anchorRect = anchor.getBoundingClientRect();
        gLog.push('slideRect=' + JSON.stringify({t: Math.round(slideRect.top), l: Math.round(slideRect.left), w: Math.round(slideRect.width), h: Math.round(slideRect.height)}));
        gLog.push('anchorRect=' + JSON.stringify({t: Math.round(anchorRect.top), l: Math.round(anchorRect.left), w: Math.round(anchorRect.width), h: Math.round(anchorRect.height)}));

        if (slideRect.width === 0 || slideRect.height === 0) {
          gLog.push('SKIPPED: zero-size slide rect');
          log = log.concat(gLog);
          continue;
        }

        group.style.position = 'absolute';
        group.style.inset = 'auto';
        group.style.top = (slideRect.top - anchorRect.top) + 'px';
        group.style.left = (slideRect.left - anchorRect.left) + 'px';
        group.style.width = slideRect.width + 'px';
        group.style.height = slideRect.height + 'px';

        var cs = window.getComputedStyle(group);
        gLog.push('AFTER: position=' + cs.position + ' top=' + cs.top + ' left=' + cs.left + ' width=' + cs.width + ' height=' + cs.height + ' display=' + cs.display + ' visibility=' + cs.visibility + ' opacity=' + cs.opacity);
        gLog.push('group.getBoundingClientRect=' + JSON.stringify(group.getBoundingClientRect()));

        var btns = group.querySelectorAll('.ed-bg-btn-free');
        for (var b = 0; b < btns.length; b++) {
          var br = btns[b].getBoundingClientRect();
          var bcs = window.getComputedStyle(btns[b]);
          gLog.push('  btn[' + b + '] "' + btns[b].textContent.trim() + '" style.top=' + btns[b].style.top + ' style.left=' + btns[b].style.left + ' computed.position=' + bcs.position + ' rect=' + JSON.stringify({t: Math.round(br.top), l: Math.round(br.left), w: Math.round(br.width), h: Math.round(br.height)}));
        }

        log = log.concat(gLog);
      }
    } catch (err) {
      log.push('ERROR: ' + (err && err.message ? err.message : String(err)));
      if (err && err.stack) log.push(err.stack);
    }

    if (debug) renderDebug(log);
  }

  var scheduled = debounce(positionFreeGroups, 150);

  document.addEventListener('DOMContentLoaded', positionFreeGroups);
  window.addEventListener('load', positionFreeGroups);
  window.addEventListener('resize', scheduled);
  window.addEventListener('orientationchange', scheduled);

  /* Slideshow images/fonts can finish loading slightly after first paint,
     which changes slide height — re-measure a couple of times shortly after
     load to catch that without polling forever. */
  setTimeout(positionFreeGroups, 400);
  setTimeout(positionFreeGroups, 1200);

  /* Run immediately too, in case DOMContentLoaded already fired before this
     deferred script executed. */
  if (document.readyState !== 'loading') {
    positionFreeGroups();
  }
})();
